import React, { useState } from 'react';
import PropTypes from 'prop-types';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import DeleteIcon from '@mui/icons-material/Delete';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import UserFields from './UserFields';
import { ViewType } from '../../Enums';
import './FunctionBar.css';

const FunctionBar = ({
  onAssign,
  onDelete,
  onAnalyse,
  selectedViewType,
  onCreateUser,
  isAnalysing = false,
}) => {
  const [showFields, setShowFields] = useState(false);
  return (
    <div className="function-bar">
      {selectedViewType === ViewType.USERS ? (
        // Add User Button for Users view
<>
  <button 
    className="function-bar-button function-bar-button-icon-text" 
    onClick={() => setShowFields(!showFields)}
  >
    <PersonAddIcon sx={{ color: 'white', marginRight: '8px' }} /> 
    Add User
  </button>

  {/* Use a div for proper positioning & layout */}
  {showFields && (
    <div className="function-bar-user-fields">
      <UserFields onCreateUser={(newUser) => {
        onCreateUser(newUser);
        setShowFields(!showFields);
      }} />
    </div>
  )}
</>

      ) : (
        // Assign and Delete Buttons for other views
        <>
          <button className="function-bar-button function-bar-button-icon-text" onClick={onAssign}>
            <AssignmentIndIcon sx={{ color: 'white', marginRight: '6px' }} /> ASSIGN
          </button>

          {onAnalyse && (
            <button
              className="function-bar-button function-bar-button-icon-text"
              onClick={onAnalyse}
              disabled={isAnalysing}
            >
              <AutoAwesomeIcon sx={{ color: 'white', marginRight: '6px' }} />
              {isAnalysing ? "ANALYSING" : "ANALYSE"}
            </button>
          )}
          
          {<button className="function-bar-button function-bar-button-icon-text" onClick={onDelete}>
            <DeleteIcon sx={{ color: 'white', marginRight: '6px' }} /> DELETE
          </button>}
        </>
      )}
    </div>
  );
};

FunctionBar.propTypes = {
  onAssign: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onAnalyse: PropTypes.func,
  selectedViewType: PropTypes.string.isRequired,
  isAnalysing: PropTypes.bool,
};

export default FunctionBar;
